import styled from 'styled-components';

export const WrapperFooter = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    .footer-content {
        display: flex;
        flex-direction: column;
    }
    .volver span {
        text-decoration: inherit;
        font-weight: 500;
        color: #E81E2B;
    }
    .volver.btn-comprobante span {
        text-decoration: inherit;
        font-weight: 500;
        color: #E81E2B;
        margin: 0px 5px 0px 318px;
        font-size: 1rem;
    }
    .volver.btn-comprobante button::after {
        content: ">";
        font-size: 27px;
        font-weight: 500;
        position: relative;
        top: 0px;
        left: 10px;
        color: #E81E2B;
    }
    .volver.btn-comprobante button::before{
        content: none;
    }
    .volver button::before {
        content: "<";
        font-size: 27px;
        font-weight: 500;
        position: relative;
        right: 20px;
        top: -2px;
    }
    .verificar button {
        min-width: 190px;
        color: white;
        background-color: #e81e2b;
    }
    .verificar button:hover {
        color: white;
        background-color: #e81e2b;
    }
    .verificar button:disabled {
        background-color: #d4d4d4;
        color: #fff;
    }
    @media (max-width: 768px){
        .volver.btn-comprobante span {
            margin: 0px 0px 0px 300px;
            font-size: 0.9rem;
        }
    }
    @media (max-width: 426px){
        flex-direction: column;
        button{
            font-size: 1rem;
        }
        .verificar button, .volver button {
            font-size: 0.8rem;
        }
        .volver button::before{
            right: 12px;
        }
        .volver.btn-comprobante span {
            margin: 0px 0px 0px 0px;
            font-size: 0.9rem;
        }
    }
    @media (max-width: 321px){
        .verificar button, .volver button {
            font-size: 0.8rem;
        }
        .volver.btn-comprobante span {
            margin: 0px 0px 0px 0px;
            font-size: 0.9rem;
        }
    }
`;



export default WrapperFooter;